"use strict";

/**
 * @module indicative-rules
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
const indicative_utils_1 = require("indicative-utils");
const linksRegex = /<a\b[^>]*>(.*?)<\/a>/g;
/**
 * Strips `a` tags from a given string.
 *
 * ```ts
 * import { sanitizations } from 'indicative/sanitizer'
 *
 * const sanitizationRules = {
 *   message: 'strip_links'
 * }
 *
 * // or
 * const sanitizationRules = {
 *   message: [
 *     sanitizations.stripLinks()
 *   ]
 * }
 * ```
 */
const stripLinks = {
  sanitize(data, field) {
    let fieldValue = indicative_utils_1.getValue(data, field);
    if (typeof fieldValue !== 'string') {
      return;
    }
    indicative_utils_1.patchValue(data, field, fieldValue.replace(linksRegex, (_match, group) => group.trim()));
  }
};
exports.default = stripLinks;